export const ActionTypes = {
  INITIALIZE: 'feature/horizontal/INITIALIZE',
  SIZE_CHANGE: 'feature/horizontal/SIZE_CHANGE',
  START_FREE_SCROLL: 'feature/horizontal/START_FREE_SCROLL',
  CANCEL_FREE_SCROLL: 'feature/horizontal/CANCEL_FREE_SCROLL',
  UPDATE_LEFT_AND_RIGHT: 'feature/horizontal/UPDATE_LEFT_AND_RIGHT',
  TIMELINE_ITEM_DRILL_DOWN: 'feature/horizontal/TIMELINE_ITEM_DRILL_DOWN',
  TIMELINE_ITEM_DRILL_OUT: 'feature/horizontal/TIMELINE_ITEM_DRILL_OUT',
}
export const INITIALIZE = ActionTypes.INITIALIZE
export const SIZE_CHANGE = ActionTypes.SIZE_CHANGE
export const START_FREE_SCROLL = ActionTypes.START_FREE_SCROLL
export const CANCEL_FREE_SCROLL = ActionTypes.CANCEL_FREE_SCROLL
export const UPDATE_LEFT_AND_RIGHT = ActionTypes.UPDATE_LEFT_AND_RIGHT
export const TIMELINE_ITEM_DRILL_DOWN = ActionTypes.TIMELINE_ITEM_DRILL_DOWN
export const TIMELINE_ITEM_DRILL_OUT = ActionTypes.TIMELINE_ITEM_DRILL_OUT

// Default export for convenient namespaced access
export default ActionTypes
